import rateCalc from '../../../assets/images/feature/feature-homeBanner-03.png';

export const RATE_CALC_BANNER = [
  {
    key: '이자 계산기',
    primaryText: '이자 계산기',
    secondaryText: '매월 상환 금액을 계산해보세요',
    logoImgUrl: rateCalc,
  },
];
